import { render, staticRenderFns } from "./OSelect.vue?vue&type=template&id=6a4b9818"
import script from "./OSelect.vue?vue&type=script&lang=js"
export * from "./OSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports